import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7xecg84a7q: FaireBrandEntity = {
  token: "b_7xecg84a7q",
  type: "brand",
  name: "90 Degree by Reflex & Yogalicious",
  avatarUrl:
    "https://cdn.faire.com/fastly/990b2231bfd110757fa96c0f8d04c439b177ff401f080748d6746e92799571e5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6cd133222b9b7c23cdcc6782ffa5f26abf583fb63bc01257289a1587d996729d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/990b2231bfd110757fa96c0f8d04c439b177ff401f080748d6746e92799571e5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6cd133222b9b7c23cdcc6782ffa5f26abf583fb63bc01257289a1587d996729d.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 73,
  isInsider: true,
  description:
    "From the yoga studio to brunch plans, your lifestyle is as dynamic as you are - and it’s about time your activewear kept up. That’s where we come in. \n\nUnder the 90 Degree  Label, we aim to push the boundaries between functional sportswear and progressive street style, licensing women to be bold. We pride ourselves on producing high quality garments that are not only affordable and accessible, but also bestow self-confidence in the wearer.\n\nWe lead activewear technological advancements by designing and innovating garments that feature antimicrobial and moisture-wicking properties with luxurious finishes that inspire any gym to street look. Our best-selling Powerflex and Interlink fabrics offer squat proof protection and four-way stretch, making them an everyday essential. For the athlete seeking additional compression and durability, we have Hypertek. Lastly, we have our fleece-lined Cold Gear that keeps our customers warm during the winter months, whether they're taking the ski slopes or relaxing at home.\n\nOur success in pleasing both the everyday fashion consumer and the ultimate active enthusiast is reflected by our devoted customer base.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:53.471Z",
    importedBy: "entity-db-cli",
  },
};
